import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const NAV_LINKS = ['Home', 'About', 'Academics', 'Admissions', 'Gallery', 'Contact'];

// SVG Illustrations
const SchoolSVG = () => (
  <svg viewBox="0 0 400 300" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', maxWidth: 420 }}>
    <rect x="80" y="120" width="240" height="160" rx="4" fill="#1a73e8" opacity="0.15"/>
    <rect x="100" y="100" width="200" height="20" rx="4" fill="#1a73e8" opacity="0.3"/>
    <rect x="150" y="80" width="100" height="25" rx="4" fill="#1a73e8" opacity="0.5"/>
    <polygon points="170,60 200,40 230,60" fill="#1a73e8"/>
    <rect x="120" y="180" width="50" height="70" rx="4" fill="#fff" opacity="0.8"/>
    <rect x="230" y="180" width="50" height="70" rx="4" fill="#fff" opacity="0.8"/>
    <rect x="175" y="190" width="50" height="50" rx="4" fill="#1a73e8" opacity="0.6"/>
    <circle cx="200" cy="215" r="8" fill="#fff"/>
    <rect x="130" y="200" width="30" height="30" rx="3" fill="#1a73e8" opacity="0.4"/>
    <rect x="240" y="200" width="30" height="30" rx="3" fill="#1a73e8" opacity="0.4"/>
    {/* Trees */}
    <ellipse cx="60" cy="180" rx="30" ry="40" fill="#0f9d58" opacity="0.4"/>
    <rect x="56" y="200" width="8" height="30" fill="#0f9d58" opacity="0.6"/>
    <ellipse cx="340" cy="175" rx="28" ry="38" fill="#0f9d58" opacity="0.4"/>
    <rect x="336" y="195" width="8" height="35" fill="#0f9d58" opacity="0.6"/>
    {/* Flag */}
    <rect x="196" y="30" width="3" height="50" fill="#f29900"/>
    <polygon points="199,30 220,38 199,46" fill="#f29900"/>
    {/* Sun */}
    <circle cx="340" cy="60" r="25" fill="#f29900" opacity="0.3"/>
    <circle cx="340" cy="60" r="15" fill="#f29900" opacity="0.5"/>
  </svg>
);

const AcademicsSVG = () => (
  <svg viewBox="0 0 300 220" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', maxWidth: 320 }}>
    <rect x="40" y="40" width="220" height="160" rx="12" fill="#e8f0fe"/>
    <rect x="60" y="70" width="180" height="12" rx="6" fill="#1a73e8" opacity="0.4"/>
    <rect x="60" y="95" width="140" height="10" rx="5" fill="#1a73e8" opacity="0.25"/>
    <rect x="60" y="115" width="160" height="10" rx="5" fill="#1a73e8" opacity="0.25"/>
    <rect x="60" y="135" width="120" height="10" rx="5" fill="#1a73e8" opacity="0.25"/>
    <circle cx="150" cy="30" r="20" fill="#1a73e8"/>
    <path d="M140 30 L150 20 L160 30 L150 40 Z" fill="#fff" opacity="0.8"/>
  </svg>
);

export default function HomePage() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div style={{ fontFamily: "'Poppins', sans-serif", minHeight: '100vh', background: '#fff' }}>
      {/* Navbar */}
      <nav style={{ background: '#fff', boxShadow: '0 2px 16px rgba(26,115,232,0.08)', position: 'sticky', top: 0, zIndex: 100 }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 68 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 40, height: 40, background: 'linear-gradient(135deg,#1a73e8,#0f9d58)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg viewBox="0 0 24 24" fill="#fff" width="22" height="22"><path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zm0 12.5L3 11.1V15c0 2.8 4 5 9 5s9-2.2 9-5v-3.9l-9 4.4z"/></svg>
            </div>
            <div>
              <div style={{ fontWeight: 700, fontSize: '1rem', color: '#1a1f36', lineHeight: 1.1 }}>Vidya Mandir</div>
              <div style={{ fontSize: '0.7rem', color: '#6b7280' }}>Sr. Secondary School</div>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 28, alignItems: 'center' }}>
            {NAV_LINKS.map(l => (
              <a key={l} href={`#${l.toLowerCase()}`} style={{ fontSize: '0.875rem', fontWeight: 600, color: '#1a1f36', textDecoration: 'none', transition: 'color 0.15s' }}
                onMouseEnter={e => e.target.style.color = '#1a73e8'} onMouseLeave={e => e.target.style.color = '#1a1f36'}>
                {l}
              </a>
            ))}
            <button onClick={() => navigate('/login')} style={{ background: '#1a73e8', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 20px', fontFamily: 'Poppins', fontWeight: 700, fontSize: '0.875rem', cursor: 'pointer' }}>
              Login
            </button>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section id="home" style={{ background: 'linear-gradient(135deg,#f0f4ff 0%,#e8f0fe 50%,#e6f4ea 100%)', padding: '80px 24px 60px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center' }}>
          <div>
            <div style={{ display: 'inline-block', background: '#e8f0fe', color: '#1a73e8', borderRadius: 999, padding: '4px 14px', fontSize: '0.78rem', fontWeight: 700, marginBottom: 16, letterSpacing: 1 }}>
              🎓 Excellence in Education Since 1985
            </div>
            <h1 style={{ fontSize: '2.8rem', fontWeight: 700, color: '#1a1f36', lineHeight: 1.15, marginBottom: 20 }}>
              Nurturing Minds,<br /><span style={{ color: '#1a73e8' }}>Shaping Futures</span>
            </h1>
            <p style={{ fontSize: '1rem', color: '#6b7280', lineHeight: 1.7, marginBottom: 32, maxWidth: 480 }}>
              A premier institution dedicated to holistic development of students through quality education, character building, and innovation.
            </p>
            <div style={{ display: 'flex', gap: 14 }}>
              <a href="#admissions" style={{ background: '#1a73e8', color: '#fff', padding: '12px 28px', borderRadius: 10, fontWeight: 700, textDecoration: 'none', fontSize: '0.9rem' }}>Apply Now</a>
              <a href="#about" style={{ background: '#fff', color: '#1a73e8', padding: '12px 28px', borderRadius: 10, fontWeight: 700, textDecoration: 'none', fontSize: '0.9rem', border: '2px solid #1a73e8' }}>Learn More</a>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}><SchoolSVG /></div>
        </div>

        {/* Stats row */}
        <div style={{ maxWidth: 1200, margin: '48px auto 0', display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 20 }}>
          {[
            { n: '2500+', l: 'Students Enrolled' },
            { n: '120+', l: 'Expert Faculty' },
            { n: '98%', l: 'Board Pass Rate' },
            { n: '40+', l: 'Years of Excellence' },
          ].map(s => (
            <div key={s.l} style={{ background: '#fff', borderRadius: 14, padding: '20px 24px', textAlign: 'center', boxShadow: '0 2px 12px rgba(26,115,232,0.08)', border: '1px solid #e0e7ff' }}>
              <div style={{ fontSize: '2rem', fontWeight: 700, color: '#1a73e8' }}>{s.n}</div>
              <div style={{ fontSize: '0.82rem', color: '#6b7280', fontWeight: 600, marginTop: 4 }}>{s.l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* About */}
      <section id="about" style={{ padding: '80px 24px', background: '#fff' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <h2 style={{ fontSize: '2rem', fontWeight: 700, color: '#1a1f36' }}>About Our School</h2>
            <p style={{ color: '#6b7280', marginTop: 10, maxWidth: 560, margin: '10px auto 0' }}>
              Vidya Mandir Senior Secondary School has been at the forefront of quality education for over four decades.
            </p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center' }}>
            <div><AcademicsSVG /></div>
            <div>
              {[
                { t: '🎯 Our Mission', d: 'To provide world-class education that empowers students to become responsible global citizens.' },
                { t: '👁 Our Vision', d: 'Creating a learning environment that fosters creativity, critical thinking, and compassion.' },
                { t: '⭐ Our Values', d: 'Integrity, Excellence, Inclusion, Innovation, and Community — the pillars of Vidya Mandir.' },
              ].map(i => (
                <div key={i.t} style={{ marginBottom: 24, padding: '18px 22px', background: '#f8faff', borderRadius: 12, borderLeft: '4px solid #1a73e8' }}>
                  <div style={{ fontWeight: 700, marginBottom: 6, color: '#1a1f36' }}>{i.t}</div>
                  <div style={{ fontSize: '0.9rem', color: '#6b7280', lineHeight: 1.6 }}>{i.d}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Academics */}
      <section id="academics" style={{ padding: '80px 24px', background: '#f8faff' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <h2 style={{ fontSize: '2rem', fontWeight: 700, color: '#1a1f36' }}>Academic Programs</h2>
            <p style={{ color: '#6b7280', marginTop: 10 }}>Comprehensive curriculum designed for holistic development</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 22 }}>
            {[
              { icon: '📚', title: 'Classes 9 & 10', desc: 'CBSE curriculum with strong foundation in core subjects and co-curricular activities.', color: '#e8f0fe' },
              { icon: '🔬', title: 'Science Stream (11-12)', desc: 'Physics, Chemistry, Biology/Math with modern labs and expert faculty guidance.', color: '#e6f4ea' },
              { icon: '📊', title: 'Commerce Stream (11-12)', desc: 'Accountancy, Business Studies, Economics with practical industry exposure.', color: '#fef3e2' },
              { icon: '💻', title: 'Computer Science', desc: 'Cutting-edge CS curriculum covering programming, AI, and digital literacy.', color: '#ede7f6' },
              { icon: '🎨', title: 'Arts & Culture', desc: 'Music, Dance, Fine Arts, Drama — nurturing creative talents alongside academics.', color: '#fce8e6' },
              { icon: '⚽', title: 'Sports & Athletics', desc: 'State-of-the-art sports facilities for cricket, football, basketball, and more.', color: '#e8f0fe' },
            ].map(c => (
              <div key={c.title} style={{ background: '#fff', borderRadius: 16, padding: '24px', boxShadow: '0 2px 12px rgba(0,0,0,0.05)', border: '1px solid #e0e7ff', transition: 'transform 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-4px)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}>
                <div style={{ width: 50, height: 50, background: c.color, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', marginBottom: 16 }}>{c.icon}</div>
                <h3 style={{ fontWeight: 700, marginBottom: 8, fontSize: '1rem' }}>{c.title}</h3>
                <p style={{ fontSize: '0.85rem', color: '#6b7280', lineHeight: 1.6 }}>{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Admissions */}
      <section id="admissions" style={{ padding: '80px 24px', background: 'linear-gradient(135deg,#1a73e8,#0d47a1)' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto', textAlign: 'center', color: '#fff' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: 16 }}>Admissions Open 2024-25</h2>
          <p style={{ opacity: 0.85, marginBottom: 32, fontSize: '1rem', lineHeight: 1.7, maxWidth: 600, margin: '0 auto 32px' }}>
            Join our vibrant community of learners. Limited seats available for Classes 9-12. Merit-based admissions.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 20, marginBottom: 36, maxWidth: 800, margin: '0 auto 36px' }}>
            {['Submit Form', 'Entrance Test', 'Interview', 'Admission'].map((step, i) => (
              <div key={step} style={{ background: 'rgba(255,255,255,0.12)', borderRadius: 12, padding: '16px 12px', backdropFilter: 'blur(8px)' }}>
                <div style={{ width: 32, height: 32, background: 'rgba(255,255,255,0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, margin: '0 auto 8px' }}>{i+1}</div>
                <div style={{ fontSize: '0.82rem', fontWeight: 700 }}>{step}</div>
              </div>
            ))}
          </div>
          <button onClick={() => navigate('/signup')} style={{ background: '#fff', color: '#1a73e8', border: 'none', padding: '14px 36px', borderRadius: 10, fontFamily: 'Poppins', fontWeight: 700, fontSize: '1rem', cursor: 'pointer' }}>
            Register Now
          </button>
        </div>
      </section>

      {/* Gallery placeholder */}
      <section id="gallery" style={{ padding: '80px 24px', background: '#fff' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: 10 }}>School Gallery</h2>
          <p style={{ color: '#6b7280', marginBottom: 36 }}>Glimpses of our vibrant school life</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16 }}>
            {['Annual Day 🎭', 'Sports Day ⚽', 'Science Fair 🔬', 'Art Exhibition 🎨', 'Cultural Fest 🎵', 'Graduation Day 🎓'].map((label, i) => (
              <div key={label} style={{ background: `hsl(${210 + i * 20},70%,${88 - i * 3}%)`, borderRadius: 16, height: 160, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem', fontWeight: 700, color: '#1a1f36' }}>
                {label}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" style={{ padding: '80px 24px', background: '#f8faff' }}>
        <div style={{ maxWidth: 900, margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: 10 }}>Contact Us</h2>
          <p style={{ color: '#6b7280', marginBottom: 40 }}>Get in touch with us for any queries or information</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 22, marginBottom: 40 }}>
            {[
              { icon: '📍', t: 'Address', v: 'Vidya Mandir School, Main Road,\nJaipur, Rajasthan 302001' },
              { icon: '📞', t: 'Phone', v: '+91 141-4567890\n+91 98765-43210' },
              { icon: '✉️', t: 'Email', v: 'info@vidyamandir.edu.in\nadmissions@vidyamandir.edu.in' },
            ].map(c => (
              <div key={c.t} style={{ background: '#fff', borderRadius: 14, padding: '24px', boxShadow: '0 2px 12px rgba(0,0,0,0.05)', border: '1px solid #e0e7ff' }}>
                <div style={{ fontSize: '2rem', marginBottom: 10 }}>{c.icon}</div>
                <div style={{ fontWeight: 700, marginBottom: 6 }}>{c.t}</div>
                <div style={{ fontSize: '0.85rem', color: '#6b7280', whiteSpace: 'pre-line', lineHeight: 1.6 }}>{c.v}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ background: '#0d1b2a', color: 'rgba(255,255,255,0.6)', padding: '32px 24px', textAlign: 'center' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div style={{ fontWeight: 700, color: '#fff', marginBottom: 8, fontSize: '1rem' }}>Vidya Mandir Sr. Secondary School</div>
          <div style={{ fontSize: '0.82rem', marginBottom: 16 }}>Affiliated to CBSE | School No. 12345</div>
          <div style={{ fontSize: '0.78rem' }}>© 2024 Vidya Mandir. All rights reserved. |
            <button onClick={() => navigate('/login')} style={{ background: 'none', border: 'none', color: '#1a73e8', cursor: 'pointer', fontFamily: 'Poppins', fontSize: '0.78rem', marginLeft: 8 }}>Staff Portal</button>
          </div>
        </div>
      </footer>
    </div>
  );
}
